export default __webpack_public_path__ + "static/media/alt-med.764463ec.jpg";